<template>
  <div class="app-main-content warn-rule">
    <div
      v-show="showMainList"
      class="main-content"
      type="primary"
    >
      <div class="cargo-advance-search">
        <div style="height: auto;width: 100%;" class="cargo-advance-search quotation-client-search">
          <div class="cargo-advance-search-header">
            <el-form label-width="65px" label-position="left" style="margin-right: 5px; min-width: 1100px">
              <el-row :gutter="10">
                <el-col :span="4">
                  <el-form-item :label="$t('CargoMsg.Cargo_BusinessType')">
                    <cargo-advance-select
                      :select-type="selectTypeNames.local_cache_SystemConstants$LOBS"
                      :show-custom-label-in-option="true"
                      :default-value="filter.lob"
                      :clearable="false"
                      style="width: 100px"
                      @parentCallBack="p=>{filter.lob=p.value}"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="5">
                  <el-form-item :label="$t('CargoMsg.Cargo_SopTemplate')" style="margin-left: 5px">
                    <cargo-advance-select
                      :static-options="lobTemplates"
                      :cache="false"
                      tag-value="uuid"
                      tag-name="templateName"
                      :default-value="filter.trackingTemplateUuid"
                      style="width: 150px"
                      @parentCallBack="p=>{filter.trackingTemplateUuid=p.value}"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="5">
                  <el-form-item :label="$t('CargoMsg.Cargo_WarningConditions')" style="margin-left: 5px">
                    <cargo-advance-select
                      :cache="false"
                      :static-options="alertTypes"
                      :default-value="filter.warningDateField"
                      tag-value="code"
                      filterable
                      style="width: 150px"
                      @parentCallBack="p=>{filter.warningDateField=p.value}"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="5">
                  <el-form-item :label="$t('CargoMsg.Cargo_WarningContent')" style="margin-left: 5px">
                    <el-input v-model="filter.content" />
                  </el-form-item>
                </el-col>
                <el-col :span="5">
                  <el-form-item :label="$t('SystemMaintenance.ConfigurationName')" style="margin-left: 5px">
                    <el-input v-model="filter.configureName" />
                  </el-form-item>
                </el-col>
                <el-col :span="5">
                  <el-form-item class="label-max" :label="$t('CargoMsg.Cargo_AlertOnStatus')" style="margin-left: 5px">
                    <cargo-advance-select
                      :cache="false"
                      :static-options="switchList"
                      :default-value="filter.open"
                      tag-value="code"
                      filterable
                      style="width: 100px"
                      @parentCallBack="p=>{filter.open=p.value}"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
            <div style="display: flex; align-items: flex-start">
              <el-button type="primary" @click="toQuery">
                {{ $t('Pricing.Query') }}
              </el-button>
              <el-button v-show="['SE'/*, 'AE'*/].indexOf(filter.lob) > -1" type="success" @click="onDataServiceReminder()">{{ $t('CargoMsg.Cargo_DataServiceReminder') }}</el-button>
              <el-button v-show="['SE'/*, 'AE'*/].indexOf(filter.lob) > -1" type="success" @click="onValueAddedServiceReminder()">{{ $t('CargoMsg.Cargo_ValueAddedServiceReminder') }}</el-button>
              <el-button type="primary" @click="onEdit()">{{ $t('CargoMsg.Cargo_Edit') }}</el-button>
              <el-button type="danger" @click="onClose()">{{ $t('CargoMsg.Cargo_Close') }}</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="grid-view">
      <div class="main-content">
        <div class="section grid-wrapper">
          <cargo-ag-grid
            config-module="260306"
            :wrap-text="true"
            :grid-params.sync="gridParams"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
            @gridReady="params=>{gridApi=params.api}"
          />
        </div>
        <div class="pagination-wrapper">
          <cargo-pagination
            config-module="260306"
            :total="filter.total"
            :page.sync="filter.pageNum"
            :limit.sync="filter.pageSize"
            @pagination="toQuery"
          />
        </div>
      </div>
    </div>
    <!-- 编辑弹窗 -->
    <warn-rule-form
      v-if="warnRuleFormDialog.visible"
      :visible.sync="warnRuleFormDialog.visible"
      :readonly="false"
      :source="warnRuleFormDialog.form"
      :alert-types.sync="warnRuleFormDialog.alertTypes"
      :complete-node-status="warnRuleFormDialog.completeNodeStatus"
      @reload="clearSelectRow"
      @close="warnRuleFormDialog.visible=false"
    />
    <!-- 数据服务提醒 -->
    <data-service-reminder-form
      v-if="reminderFormDialog.visible"
      :visible.sync="reminderFormDialog.visible"
      :readonly="false"
      :params="filter"
      :load-data="loadData"
      :alert-types.sync="reminderFormDialog.alertTypes"
      :open-subscribe="openSubscribe"
      @reload="toQuery"
      @close="reminderFormDialog.visible=false"
    />
    <ams-vgm-reminder-form
      v-if="valueAddedFormDialog.visible"
      :visible.sync="valueAddedFormDialog.visible"
      :readonly="false"
      :params="filter"
      @reload="toQuery"
      @close="valueAddedFormDialog.visible=false"
    />
  </div>
</template>

<script>

import { getLoading } from '@/utils/utilBaseElement'
import URL from '@/api/urlTranslator'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { closeByBatchIds, delWarningRule, getWarningRuleList } from '@/api/sysManage/baseConfig/warnRuleConfiguration'
import WarnRuleForm from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/warnRuleConfiguration/warnRuleForm'
import DataServiceReminderForm
  from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/warnRuleConfiguration/dataServiceReminderForm'
import { SopUtil } from '@/class/cargo/model/utils/SopUtil'
import * as CargoOfRoleType from '@/class/cargo/model/parameters/CargoOfRoleType'
import * as SopConstants from '@/class/cargo/model/parameters/SopConstants'
import { getOpenSubscribe, queryCompleteTrackingDetails } from '@/api/sysManage/baseConfig/businessManage'
import AmsVgmReminderForm
  from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/warnRuleConfiguration/amsVgmReminderForm.vue'

export default {
  name: 'WarnRuleConfiguration',
  components: { AmsVgmReminderForm, DataServiceReminderForm, WarnRuleForm, CargoAdvanceSelect },
  props: {},
  data() {
    return {
      URL,
      selectTypeNames: TYPE_NAMES,
      completeTrackingInfoMap: {}, // 对应模板已完成的节点状态列表， key为模板uuid,值为对应的节点状态列表
      openSubscribe: null,
      selectedRow: null,
      warnRules: [],
      switchList: SopConstants.SWITCH,
      templateList: [],
      filter: {
        lob: 'SE',
        trackingTemplateUuid: '',
        content: '',
        alertRemindType: '',
        branchId: 0,
        total: 0,
        pageNum: 1,
        pageSize: 10,
        open: 1,
        warningRuleUuid: '',
        configureName: ''
      },
      warnRuleFormDialog: {
        visible: false,
        form: {},
        alertTypes: []
      },
      reminderFormDialog: {
        visible: false,
        alertTypes: [],
        form: {}
      },
      valueAddedFormDialog: {
        visible: false,
        alertTypes: []
      },
      gridParams: {},
      gridApi: null,
      showDetail: false,
      fullscreenLoading: null,
      isZh: this.$store.getters.language === 'zh',
      loadData: false,
      rowData: [],
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        onRowClicked: this.onRowClickedEvent,
        onRowDoubleClicked: this.onRowDoubleClicked,
        onRowSelected: this.onRowChecked
      },
      columnDefs: [
        {
          headerName: ' ', checkboxSelection: true, maxWidth: 40,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_EarlyWarning'), field: 'lob', colId: 'lob',
          valueFormatter: (params) => {
            return ColumnUtils.jobBussStateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_SopTemplate'), field: 'templateName', colId: 'templateName'
        },
        {
          headerName: this.$t('CargoMsg.Cargo_SopNode'), field: 'trackingName', colId: 'trackingName'
        },
        {
          headerName: this.$t('CargoMsg.Cargo_WarningConditions'), field: 'warningDateField', colId: 'warningDateField',
          valueFormatter: (params) => {
            return SopUtil.warningConditionsLabelFunc(this.warnRules, params)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_WarningContent'), field: 'content', colId: 'content'
        },
        {
          headerName: this.$t('CargoMsg.Cargo_RemarksInfo'), field: 'remark', colId: 'remark'
        },
        {
          headerName: this.$t('CargoMsg.Cargo_DesignatedPost'), field: 'notifierRoles', colId: 'notifierRoles',
          valueFormatter: (params) => {
            return SopUtil.notifierRolesLabelFunc(CargoOfRoleType.WARNING_ROLE_TYPES, params)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_DesignatedPersonnel'), field: 'notifierIds', colId: 'notifierIds',
          valueFormatter: (params) => {
            return SopUtil.notifierIdsLabelFunc(params)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_AutoIgnoreMode'), field: 'ignoreType', colId: 'ignoreType',
          valueFormatter: (params) => {
            return SopUtil.autoIgnoreModeLabelFunc(params)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_WarningLevel'), field: 'level', colId: 'level',
          valueFormatter: (params) => {
            return SopUtil.warningLevelsLabelFunc(params)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_AlertOnStatus'), field: 'open', colId: 'open',
          valueFormatter: (params) => {
            return SopUtil.alertOnStatusLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_EarlyWarningMode'), field: 'type', colId: 'type',
          valueFormatter: (params) => {
            return SopUtil.earlyWarningModeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_DataServiceConfig'), field: 'configureName', colId: 'configureName'
        }
      ]
    }
  },
  computed: {
    showMainList() {
      return !this.showDetail
    },
    lobTemplates() {
      if (!this.templateList || this.templateList.length === 0) {
        return []
      }
      return this.templateList.filter(item => item.lob === this.filter.lob)
    },
    alertTypes() {
      return this.warnRules.filter(item => item.lob === this.filter.lob && item.warnType === 1)
    }
  },
  watch: {
    '$store.getters.currentOfficeId': function() {
      this.toQuery()
    }
  },
  async mounted() {
    const sopConfig = await SopUtil.getInstance()
    this.warnRules = sopConfig.warnDateEnum
    this.templateList = sopConfig.templateList
    if (this.openSubscribe === null) {
      getOpenSubscribe().then(resp => {
        this.openSubscribe = resp.data
      })
    }
    this.toQuery()
  },
  methods: {
    toQuery() {
      const params = this.filter
      if (this.filter.configureName) {
        params.configureName = this.filter.configureName.trim()
      }
      params.branchId = this.$store.getters.currentOfficeId
      this.fullscreenLoading = getLoading()
      getWarningRuleList(params).then((res) => {
        this.rowData = res.data.list
        this.filter.pageNum = res.data.pageNum
        this.filter.pageSize = res.data.pageSize
        this.filter.total = Number(res.data.total)
        this.filter.warningRuleUuid = ''
        this.loadingEnd()
        if (this.rowData && this.rowData.length === 0) {
          this.$message.warning(this.$t('Pricing.NoRecord'))
          return
        }
      }).catch(() => {
        this.fullscreenLoading.close()
      })
    },
    // 数据服务提醒
    onDataServiceReminder() {
      const alertTypes = this.warnRules.filter(item => item.lob === this.filter.lob && item.warnType === 2)
      this.reminderFormDialog.alertTypes = alertTypes
      this.reminderFormDialog.visible = true
      this.loadData = false
    },
    // 增值服务提醒
    onValueAddedServiceReminder() {
      this.valueAddedFormDialog.visible = true
      this.loadData = false
    },
    // 编辑预警信息
    onEdit() {
      if (!this.selectedRow) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseChooseData'))
        return
      }
      const alertTypes = this.warnRules.filter(item => item.lob === this.selectedRow.lob && item.warnType === this.selectedRow.type)
      if (this.selectedRow.type === 2) { // 选中的是提醒时，打开提醒页面
        this.reminderFormDialog.alertTypes = alertTypes
        this.filter.warningRuleUuid = this.selectedRow.uuid
        this.reminderFormDialog.visible = true
        this.loadData = true
        return
      }
      const templateKey = this.selectedRow.trackingTemplateUuid
      if (this.completeTrackingInfoMap.hasOwnProperty(templateKey)) {
        this.showWarnRuleFormDialog(alertTypes, this.completeTrackingInfoMap[templateKey])
        return
      }
      queryCompleteTrackingDetails({ sopTemplateKey: templateKey }).then(res => {
        const completeNodeStatus = res.data
        this.completeTrackingInfoMap[templateKey] = completeNodeStatus
        this.showWarnRuleFormDialog(alertTypes, completeNodeStatus)
      })
    },
    showWarnRuleFormDialog(alertTypes, completeNodeStatus) {
      this.warnRuleFormDialog.form = this.selectedRow
      this.warnRuleFormDialog.alertTypes = alertTypes
      this.warnRuleFormDialog.completeNodeStatus = completeNodeStatus
      this.warnRuleFormDialog.visible = true
    },
    // 关闭预警
    onClose() {
      const selectedRows = this.getSelectedRows()
      if (selectedRows === null) {
        return
      }
      this.$confirm(this.$t('CargoMsg.Cargo_WhetherToTurnOffAlerts'), this.$t('Message.Prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        const uuids = this.getSelectUuids(selectedRows)
        this.fullscreenLoading = getLoading()
        closeByBatchIds({ uuid: uuids }).then(res => {
          this.$message.success(this.$t('Message.OperationSuccessfully'))
          for (const row of selectedRows) {
            row.open = 0
          }
          this.gridOptions.api.refreshCells({ force: true })
          this.gridOptions.api.clearFocusedCell()
        }).finally(() => {
          this.loadingEnd()
        })
      })
    },
    loadingEnd() {
      this.gridOptions.api.clearFocusedCell()
      this.fullscreenLoading.close()
    },
    onDelete() {
      const selectedRows = this.getSelectedRows()
      if (selectedRows === null) {
        return
      }
      this.$confirm(this.$t('Pricing.IsDeleteRecord'), this.$t('Message.Prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        const uuids = this.getSelectUuids(selectedRows)
        this.fullscreenLoading = getLoading()
        delWarningRule({ uuid: uuids }).then(res => {
          this.$message.success(this.$t('Pricing.HasDeleted'))
          this.gridOptions.api.updateRowData({ remove: selectedRows })
        }).finally(() => {
          this.loadingEnd()
        })
      })
    },
    // 获取勾选数据
    getSelectedRows() {
      const { api } = this.gridOptions
      const selectedRows = api.getSelectedRows()
      if (selectedRows.length === 0) {
        this.$message.warning(this.$t('Pricing.NoRecordSelect'))
        return null
      }
      return selectedRows
    },
    getSelectUuids(selectedRows) {
      const uuids = []
      selectedRows.forEach(item => {
        uuids.push(item.uuid)
      })
      return uuids.join(',')
    },
    // 行首多选框勾选事件
    onRowChecked(event) {
      if (event.node.isSelected()) {
        this.onRowClickedEvent(event)
      }
    },
    onRowClickedEvent(e) {
      const data = e.data
      this.selectedRow = data
    },
    onRowDoubleClicked(e) {
      const data = e.data
      this.selectedRow = data
      this.onEdit()
    },
    clearSelectRow() {
      this.warnRuleFormDialog.visible = false
      this.gridOptions.api.clearFocusedCell()
      this.warnRuleFormDialog.form.warningRuleItemList = this.warnRuleFormDialog.form.warningRuleItemList.filter(p => p.action !== 2)
      this.gridOptions.api.refreshCells({ force: true })
    }
  }
}
</script>

<style lang="scss" scoped>
.warn-rule{
  .label-max {
    /deep/.el-form-item__label{
      width: 95px !important;
    }
  }
}
</style>
